const $ = window.jQuery

jQuery(document).ready(function ($) {
  window.setTimeout(() => {
    // Clicking the div containing the mute/unmute button should also activate the toggle.
    $('.mejs-volume-button').click(function (e) {
      if (e.target === e.currentTarget) {
        $(this).find('button').trigger('click')
      }
    })
  }, 100)
})

// Shuttles the playhead and starts playing from the timeSeconds given.
// Only works for the "first" audio player onscreen.
window.playFromTimecode = (timeValue) => {
  try {
    let timeSeconds = timeValue

    if (typeof timeValue === 'string') {
      const regex = new RegExp("[0-9]+", 'g')
      const parts = (timeValue + "").match(regex).reverse()
      timeSeconds = Math.trunc(parts[0])
      timeSeconds += parts[1] ? Math.trunc(parts[1] * 60) : 0
      timeSeconds += parts[2] ? Math.trunc(parts[2] * 3600) : 0
    }

    if (typeof timeSeconds === 'number') {
      const player = jQuery('audio')[0]
      player.setCurrentTime(timeSeconds)
      player.play()
    }
  } catch (e) {
    console.error("Could not playFromTimecode", e)
  }
}